export const PRIMARY = "#0ea5e9";
